import Clock from "@untitled-ui/icons-react/build/esm/Clock";
import XClose from "@untitled-ui/icons-react/build/esm/XClose";
import Dropdown from "react-bootstrap/Dropdown";

import { SearchHistoryItem } from "../../../../hooks";
import "./index.scss";

interface SearchHistoryDropdownProps {
  show: boolean;
  history: SearchHistoryItem[];
  onSelectSearch: (query: string) => void;
  onRemove: (query: string) => void;
  onClear: () => void;
}

export const SearchHistoryDropdown = ({
  show,
  onSelectSearch,
  history,
  onClear,
  onRemove,
}: SearchHistoryDropdownProps) => {
  if (!show || history.length === 0) {
    return null;
  }

  return (
    <Dropdown.Menu show className="search-history-dropdown">
      <div className="search-history-dropdown__header">
        <span className="search-history-dropdown__title">
          Pesquisas Recentes
        </span>

        <button className="search-history-dropdown__clear" onClick={onClear}>
          Limpar
        </button>
      </div>

      <Dropdown.Divider className="m-0" />

      {history.map((item, index) => (
        <div
          key={`${item.query}-${index}`}
          className="search-history-dropdown__item-wrapper"
        >
          <Dropdown.Item
            className="search-history-dropdown__item"
            onClick={() => onSelectSearch(item.query)}
          >
            <Clock width={16} height={16} />

            <span className="search-history-dropdown__query">{item.query}</span>

            <span className="search-history-dropdown__badge">
              {item.searchType}
            </span>
          </Dropdown.Item>

          <button
            className="search-history-dropdown__remove"
            onClick={(e) => {
              e.stopPropagation();
              onRemove(item.query);
            }}
          >
            <XClose width={14} height={14} />
          </button>
        </div>
      ))}
    </Dropdown.Menu>
  );
};
